
const checkCookieICDSwitch = function (type_cookie){
    const firstFilter = document.cookie.split("ICD_SWITCH=");

    if (firstFilter.length > 1){
        const secondFilter = firstFilter[1].split(";");
        var subStringToCheck = secondFilter[0];


        var listeValueToCheck = null;
        if(type_cookie === "YOGA") {
            listeValueToCheck = window.cmsGlobals.checkCookieYogaConfig.valueToCheck;
        }

        if(type_cookie === "CMS_TECH") {
            listeValueToCheck = window.cmsGlobals.checkCookieCMSTechConfig.valueToCheck;
        }

        function buildNode(elt){
            elt = elt.trim();
            if (subStringToCheck.includes(elt) || subStringToCheck.includes(elt.toUpperCase())) {
                var element = document.createElement("p")
                element.id = "icd_switch"+elt;
                element.style.color = "red";
                element.style.padding = "3px";
                element.style.fontWeight = 'bold';
                element.appendChild(document.createTextNode(elt));
                document.getElementsByClassName("rsp_header__wrapper-nav")[0].insertBefore(element, document.getElementsByClassName("rsp_nav")[1])
            }

        }

        if(listeValueToCheck != null) {
            listeValueToCheck.split(",").forEach(buildNode)
        }

    }
}

export {checkCookieICDSwitch};


// WEBPACK FOOTER //
// ./src/js/cms/commons/check-cookie-yoga.js